import { Box, MenuItem, Alert } from '@mui/material';
import {
  CustomAutoComplete,
  CustomTextField,
  CustomCheckbox,
  CustomButton,
  HorizontalForm,
} from '../../../common/components';
import { Add as AddIcon, Save as SaveIcon } from '@mui/icons-material';

const MovementDraftForm = ({
  draft,
  errors = {},
  movementTypes = [],
  bankAccounts = [],
  onChange,
  onCheckboxChange,
  onSubmit,
  requiresBankAccount = true,
  isEditing = false,
}) => {
  const isAddDisabled = !movementTypes.length;
  const selectedMovementType = movementTypes.find((type) => type.uuid === draft.uuid_movement_type);
  const showExchangeCheckbox = Boolean(
    selectedMovementType?.description?.toLowerCase().includes('cheque')
  );

  const fieldWidth = { xs: '100%', md: 240 };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <HorizontalForm
      variant="twoRows"
      withBorder={false}
      sx={{ gap: 2, alignItems: 'flex-start' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          columnGap: 1.5,
          rowGap: 1.5,
        }}
      >
        <CustomAutoComplete
          label="Tipo de movimiento"
          name="uuid_movement_type"
          value={draft.uuid_movement_type}
          onChange={onChange}
          error={Boolean(errors.uuid_movement_type)}
          helperText={errors.uuid_movement_type || ''}
          FormHelperTextProps={{ sx: { minHeight: 20, mt: 0.5 } }}
          required
          sx={{ width: fieldWidth }}
        >
          <MenuItem value="">Seleccionar</MenuItem>
          {movementTypes
            .filter((type) => type.is_active !== false)
            .map((type) => (
              <MenuItem key={type.uuid} value={type.uuid}>
                {type.description}
              </MenuItem>
            ))}
        </CustomAutoComplete>

        {requiresBankAccount && (
          <CustomAutoComplete
            label="Cuenta / Caja"
            name="fund_account_id"
            value={draft.fund_account_id}
            onChange={onChange}
            error={Boolean(errors.fund_account_id)}
            helperText={errors.fund_account_id || ''}
            FormHelperTextProps={{ sx: { minHeight: 20, mt: 0.5 } }}
            required
            sx={{ width: fieldWidth }}
          >
            <MenuItem value="">Seleccionar</MenuItem>
            {bankAccounts
              .filter((account) => account.is_active !== false)
              .map((account) => (
                <MenuItem key={account.uuid} value={account.uuid}>
                  {account.fund_type === 'cash'
                    ? `Caja - ${account.name}`
                    : `${(account.bank_name && account.bank_name.replace(/_/g, ' ')) || ''} - ${account.account_number}`}
                </MenuItem>
              ))}
          </CustomAutoComplete>
        )}

        <CustomTextField
          label="Fecha de emisión"
          type="date"
          name="emission_date"
          value={draft.emission_date}
          onChange={onChange}
          shrinkLabel
          required
          error={Boolean(errors.emission_date)}
          helperText={errors.emission_date}
          sx={{ width: fieldWidth }}
        />

        <CustomTextField
          label="Fecha de vencimiento"
          type="date"
          name="due_date"
          value={draft.due_date}
          onChange={onChange}
          shrinkLabel
          required
          error={Boolean(errors.due_date)}
          helperText={errors.due_date}
          sx={{ width: fieldWidth }}
        />

        <CustomTextField
          label="Número de comprobante"
          name="voucher_number"
          value={draft.voucher_number}
          onChange={onChange}
          required
          error={Boolean(errors.voucher_number)}
          helperText={errors.voucher_number}
          sx={{ width: fieldWidth }}
        />

        <CustomTextField
          label="Importe"
          name="amount"
          value={draft.amount}
          onChange={onChange}
          error={Boolean(errors.amount)}
          helperText={errors.amount}
          sx={{ width: fieldWidth }}
        />

        {/* Concepto fijo omitido en UI para no recargar el formulario */}

        {showExchangeCheckbox && (
          <CustomCheckbox
            label="Cheque de canje (no registrar en libro)"
            checked={!draft.display_in_book}
            onChange={onCheckboxChange}
            sx={{ flexBasis: { xs: '100%', md: 'auto' } }}
          />
        )}

        <Box
          sx={{
            ml: { xs: 0, md: 'auto' },
            width: { xs: '100%', sm: 'auto' },
            display: 'flex',
          }}
        >
          <CustomButton
            variant="base"
            startIcon={isEditing ? <SaveIcon /> : <AddIcon />}
            onClick={onSubmit}
            sx={{
              minWidth: 220,
              width: { xs: '100%', sm: 'auto' },
            }}
            disabled={isAddDisabled}
          >
            {isEditing ? 'Actualizar movimiento' : 'Agregar movimiento'}
          </CustomButton>
        </Box>
      </Box>
    </HorizontalForm>
    {isAddDisabled && (
      <Alert severity="warning" sx={{ mt: 2 }}>
        No hay tipos de movimiento habilitados para órdenes de pago. Configúrelos en el módulo de
        tipos de movimiento.
      </Alert>
    )}
    </Box>
  );
};

export default MovementDraftForm;
